import apiReq from '../commontools/api.js'
export function GetCityAll(){
	var url='/City/GetCityAll';
	return apiReq.get(url);
}
export function GetCityByLevel(level){
	var url='/City/GetCityByLevel/'+level;
	return apiReq.get(url);
}
export function AddCity(info){
	var url='/City/AddCity';
	// var p={
	// 	data:info
	// }
	return apiReq.post(url,info);
}
export function EditCity(info){
	var url='/City/EditCity';
	// var p={
	// 	data:info
	// }
	return apiReq.post(url,info);
}
export function DelCity(id){
	var url='/City/DelCity/'+id;
	return apiReq.get(url);
}
export default{
	GetCityAll,
	GetCityByLevel,
	AddCity,
	EditCity,
	DelCity
}